import React, {PropsWithChildren} from 'react';
import {Grid} from '@mui/material';

const GridItem: React.FC<PropsWithChildren<{className?: string}>> = ({children, ...props}) => {
  return (
    <Grid style={{maxWidth: '28.8rem', width: '100%', marginTop: 0, marginBottom: '2rem'}} {...props}>
      {children}
    </Grid>
  );
};

export default GridItem;
